import { defineComponent as _defineComponent } from 'vue'
import { computed, defineComponent } from 'vue'
export type ButtonColor = 'primary' | 'secondary'
export type ButtonVariant = 'contained' | 'outlined' | 'text' | 'elevated'
export type ButtonSize = 'sm' | 'md' | 'lg'

type ButtonProps = {
	color?: ButtonColor
	variant?: ButtonVariant
	size?: ButtonSize
	content?: string
	icon?: string
	disabled?: boolean
	loading?: boolean
	type?: 'submit' | 'button'
	block?: boolean
}
type ButtonEmits = {
	(event: 'click'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    color: { default: 'primary' },
    variant: { default: 'contained' },
    size: { default: 'md' },
    content: { default: undefined },
    icon: { default: undefined },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    type: { default: 'button' },
    block: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'click'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { color: ButtonColor, variant: ButtonVariant, size: ButtonSize, content: string, icon: string, disabled: boolean, loading: boolean, type: 'submit' | 'button', block: boolean };




const primaryContained =
	'bg-primary-60 text-white hover:bg-primary-70 hover:shadow-elevation-1 ' +
	'disabled:bg-primary-95 disabled:text-white disabled:shadow-none disabled:opacity-90'
const primaryOutlined =
	'bg-white border border-solid border-primary-60 text-primary-60 hover:bg-primary-99 ' +
	'hover:border-primary-60 focus:bg-primary-99 focus:border-primary-60 ' +
	'disabled:bg-white disabled:border-primary-95 disabled:text-primary-95'
const primaryElevated =
	'bg-secondary-90 shadow-elevation-1 text-secondary-20 hover:shadow-elevation-2 ' +
	'hover:bg-secondary-80 focus:bg-secondary-80 disabled:shadow-none ' +
	'disabled:bg-secondary-95 disabled:text-secondary-70'
const primaryText =
	'text-secondary-20 border-none hover:text-primary-60 focus:text-primary-60 disabled:text-secondary-70'

const secondaryContained =
	'bg-secondary-60 text-white hover:shadow-elevation-1 ' +
	'disabled:bg-secondary-95 disabled:text-secondary-70 disabled:shadow-none'
const secondaryOutlined =
	'bg-white border border-solid border-secondary-95 text-secondary-20 ' +
	'hover:bg-secondary-80 focus:bg-secondary-80 focus:border-secondary-20 ' +
	'disabled:bg-white disabled:border-secondary-95 disabled:text-secondary-70'
const secondaryElevated =
	'bg-secondary-90 shadow-elevation-1 text-secondary-20 hover:shadow-elevation-2 ' +
	'hover:bg-secondary-80 focus:bg-secondary-80 disabled:shadow-none ' +
	'disabled:bg-secondary-95 disabled:text-secondary-70'
const secondaryText =
	'text-secondary-50 border-none hover:text-primary focus:text-primary disabled:text-secondary-70'

const buttonVariantClassNames: Record<ButtonColor, Record<ButtonVariant, string>> = {
	primary: {
		contained: primaryContained,
		outlined: primaryOutlined,
		elevated: primaryElevated,
		text: primaryText
	},
	secondary: {
		contained: secondaryContained,
		outlined: secondaryOutlined,
		elevated: secondaryElevated,
		text: secondaryText
	}
}

const buttonSizeClassNames: Record<ButtonSize, string> = {
	sm: 'text-label-sm py-1 px-2',
	md: 'text-label-lg py-[0.625rem] px-4',
	lg: 'text-title py-4 px-7'
}

const className = computed(
	() =>
		`${buttonSizeClassNames[props.size]} ${buttonVariantClassNames[props.color][props.variant]}`
)

function handleKeyPress(event: KeyboardEvent) {
	if (event.key === 'Enter' || event.key === ' ') {
		emit('click')
	}
}

defineComponent({
	name: 'AppButton',
	inheritAttrs: false
})

return { __sfc: true,props, emit, primaryContained, primaryOutlined, primaryElevated, primaryText, secondaryContained, secondaryOutlined, secondaryElevated, secondaryText, buttonVariantClassNames, buttonSizeClassNames, className, handleKeyPress }
}

})